<footer
  class="footer"
  style="text-align: center; font-weight: 500; font-size: 14px"
>
  <div class="w-100 clearfix">
    <span class="text-center">جميع الحقوق محفوظة © ل CPTIT</span>
    <!-- <span class="float-none float-sm-right mt-1 mt-sm-0 ">Made by <a href="#" class="text-dark" target="_blank">Cptit</a></span> -->
  </div>
</footer>
